import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: "success" }
const _hoisted_2 = { class: "mt-40" }
const _hoisted_3 = { key: "form" }
const _hoisted_4 = { class: "sm:flex sm:items-center" }
const _hoisted_5 = {
  key: 0,
  class: "text-roman text-center mt-15 sm:ml-20 sm:mt-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Recaptcha = _resolveComponent("Recaptcha")!
  const _component_ProfileRequestAccessFormRenderer = _resolveComponent("ProfileRequestAccessFormRenderer")!
  const _component_ConfirmationButton = _resolveComponent("ConfirmationButton")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_Transition, {
      name: "o-anim-fade-300",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_ctx.success)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _renderSlot(_ctx.$slots, "default"),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("button", {
                  class: "c-button w-full sm:w-auto sm:min-w-250",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.setSuccess(false)), ["prevent"]))
                }, _toDisplayString(_ctx.labels.makeanotherrequest), 1)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_Form, {
                "validation-schema": _ctx.formValidation,
                onSubmit: _ctx.verifyRecaptcha
              }, {
                default: _withCtx(({ errors, handleSubmit }) => [
                  _createVNode(_component_Recaptcha, {
                    ref: "recaptcha",
                    modelValue: _ctx.recaptchaKey,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.recaptchaKey) = $event)),
                    onVerify: ($event: any) => (handleSubmit(_ctx.submit))
                  }, null, 8, ["modelValue", "onVerify"]),
                  _createVNode(_component_ProfileRequestAccessFormRenderer, { "form-elements": _ctx.formElements }, null, 8, ["form-elements"]),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_ConfirmationButton, {
                      class: "w-full sm:w-auto sm:min-w-250",
                      confirm: _ctx.pending,
                      "animation-duration": _ctx.confirmationAnimationTiming,
                      text: _ctx.labels.submitbutton,
                      "confirmation-text": _ctx.labels.submitbuttonconfirmation
                    }, null, 8, ["confirm", "animation-duration", "text", "confirmation-text"]),
                    _createElementVNode("div", null, [
                      _createVNode(_Transition, { name: "o-anim-fade-300" }, {
                        default: _withCtx(() => [
                          (_ctx.hasErrors(errors))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.labels.forminvalidtext), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["validation-schema", "onSubmit"])
            ]))
      ]),
      _: 3
    })
  ]))
}